import React, { useContext, useState, useEffect } from 'react';
import {RhyBusButton as Buttons} from '@rhybus/button';
// import {RhyBusFileUpload as FileUpload} from '@rhybus/file-upload';
import { RhyBusAlert } from '@rhybus/alert';
import {RhyBusInputText} from '@rhybus/form-controls'
import PageOverlay from '../../utils/controls/pageoverLay/pageoverLay'
import { ListNames } from '../../config/configuration';
import { rhybusRListsHttp } from '../../api/rhybus-list-http';
import { AnyAaaaRecord } from 'node:dns';
import { UserContext, UserInitalValue } from '../../store/UserContextProvider';
import FileUpload from './upload-file'
// Define reserved characters for folder/file names
const FOLDER_RES_CHAR = [',', '!', '@', '#', '$', '%', '^', '&', '*', '(', ')', '+', '=', '[', ']', '{', '}', ':', '`', '"', '|', '<', '>', '/', '?', '~'];

const AddeditView = (props: any) => {
    const { me }: typeof UserInitalValue = useContext(UserContext);
    const [noChangesAlert, setNoChangesAlert] = useState(false);
    const [loading, setLoading] = useState(false);
    const [files, setFiles] = useState<any>([]);

    // Updated validation states
    const [isName, setIsName] = useState(true);
    const [isFile, setIsFile] = useState(true);
    const [isNotAllowed, setIsNotAllowed] = useState(false);
    const [isDuplicate, setIsDuplicate] = useState(false); // Keep this for internal logic, but won't directly drive InputText error
    const [isModified, setIsModified] = useState(true); // For "No changes detected"
    const [concurrencyErrorAlert, setConcurrencyErrorAlert] = useState<{ show: boolean; message: string }>({
        show: false,
        message: ''
    });

    const trimExtension = (name: string) => {
        const parts = name?.split('.');
        if (parts && parts.length > 1) {
            parts.pop();
            return parts.join('.');
        }
        return name;
    };

    const getFileExtension = (file: any): string => {
        if (typeof file === 'string' && file.includes('.')) {
            const parts = file.split('.');
            return parts[parts.length - 1] || '';
        }
        return '';
    };
const btnBGColouredCRUDOperationsUI = {
  Add:{
    Label: 'Add',
    Icon: 'icon-rb-add font-12 pe-lg-1 ',
    ClassName: ''
  },
  Submit: {
    Label: 'Submit',
    Icon: 'icon-rb-save font-12 pe-lg-1',
    ClassName: ''
  },
  Save:{
    Label: 'Save',
    Icon: 'icon-rb-save font-12 pe-lg-1 ',
    ClassName: ''
  },
  Update:{
    Label: 'Update',
    Icon: 'icon-rb-update font-12 pe-lg-1',
    ClassName: ''
  },
  Delete:{
    Label: 'Delete',
    Icon: 'icon-rb-delete font-12 pe-lg-1',
    ClassName: ''
  },
  Cancel:{
    Label: 'Cancel',
    Icon: 'icon-rb-close color-primary font-12 pe-lg-1',
    ClassName: '',
  },
}
const getMetadata = (file: File, createdBy?: string , newFileName? :string) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const metadata: any = [];
  metadata.push({ Key: 'name', Value:newFileName ?? file.name });
  metadata.push({ Key: 'size', Value: String(file.size) });
  metadata.push({ Key: 'type', Value: String(file.type) });
  metadata.push({ Key: 'createdby', Value: createdBy });
 
  return JSON.stringify(metadata);
};
 async function UploadFiles(
    list: any,
    listname: Blob | string,
    itemkey: Blob | string,
    mdata: Blob | string,
    etag: string,
    file: File,
    blobFolder: Blob | string,
    newname?: string,
    retryCount = 0,
    blobs?: any
) {
    const formData = new FormData();
    formData.append('listName', listname);
    formData.append('itemKey', itemkey);
    formData.append('metadata', mdata);
    formData.append('blobName', file.name);
    formData.append('etag', etag ?? '');
    formData.append('blobFolder', blobFolder);
    formData.append('file', file);
 
    const MAX_RETRIES = 3;
    const BASE_DELAY_MS = 500;
 
    try {
        let fileblob;
        try {
            fileblob = await list.blobs().addOrUpdateByFormData(formData);
        } catch (apiError: any) {
            // These debug logs confirmed the structure
            console.error('DEBUG: Raw API error from addOrUpdateByFormData:', apiError);
            console.error('DEBUG: apiError.message:', apiError?.message);
            console.error('DEBUG: apiError.status:', apiError?.status);
            console.error('DEBUG: apiError.name:', apiError?.name); // New debug log for error.name
 
            // *** CRITICAL CHANGE HERE ***
            // Check if the error's 'name' property is 'ConcurrencyError'
            // OR if its string representation (like 'ConcurrencyError: filename') contains the keyword.
            const isConcurrencyErrorFromApi = (apiError?.name === 'ConcurrencyError') || (apiError?.toString()?.includes('ConcurrencyError:'));
 
            if (isConcurrencyErrorFromApi) {
                // If it's identified as a concurrency error, throw a new Error with a clear message
                // that AddeditView can reliably check for.
                const userFriendlyMessage = `ConcurrencyError: File '${file.name}' has been modified by another user. Please try again.`;
                throw new Error(userFriendlyMessage);
            }
 
            // For any other type of error from addOrUpdateByFormData, re-throw a generic message
            throw new Error(`Upload failed for ${file.name}: ${apiError?.message || apiError?.toString()}`);
        }
 
        return fileblob;
 
    } catch (error: any) {
        const errorMessage = error?.message || error?.toString() || 'Unknown Error';
 
        // Now, this check will reliably find "ConcurrencyError" in the errorMessage
        if (errorMessage.includes('ConcurrencyError') && retryCount < MAX_RETRIES) {
            console.warn(`Concurrency issue caught for ${file.name}. Retrying (${retryCount + 1}/${MAX_RETRIES})...`);
            await new Promise(resolve => setTimeout(resolve, BASE_DELAY_MS * Math.pow(2, retryCount)));
 
            const nameForRetry = getNextFileName(file.name, newname ? newname : file.name);
 
            return UploadFiles(
                list,
                listname,
                itemkey,
                mdata,
                etag,
                file,
                blobFolder,
                nameForRetry,
                retryCount + 1,
                blobs
            );
        } else {
            // If retries are exhausted or it's a different type of error, re-throw the received error
            throw error; // This error now correctly has "ConcurrencyError" in its message if applicable
        }
    }
}
 
 const listAttachments_pmg = async (
    listName: string,
    itemKey: string,
    files: File[],
    fileNames: string[], // Added for new behavior: array of names for files
    path: any,
    createdBy: string
): Promise<(any | undefined)[]> => { // Changed return type to match Promise.all
    const list :any= await rhybusRListsHttp().getList(listName);
    const blobFolder = path;
 
    // Use Promise.all to upload files in parallel
    const uploadPromises = files.map(async (file, i) => {
        const etag = ''; // Etag is still passed as empty string as per original and example
        // Assuming getMetadata now accepts the desired filename for metadata
        const mData = getMetadata(file, createdBy, fileNames[i]);
        try {
            // Pass fileNames[i] as the newname for potential retries
            return await UploadFiles(list, listName, itemKey, mData, etag, file, blobFolder, fileNames[i]);
        } catch (error: any) {
            console.error(`Error uploading file ${file.name} in listAttachments_pmg:`, error);
            throw error; // Re-throw the original error object from UploadFiles
        }
    });
 
    return Promise.all(uploadPromises); // Await all upload promises
};
 function getNextFileName(existingFile: string, fileName: string) { // Added type annotations
  // If the filename is the same as the existing file, rename it
  if (existingFile === fileName) {
      return `${fileName} (1)`;
  }
  // If the filename already has a number, increment it properly
  const match = fileName.match(/\((\d+)\)$/); // Find trailing (number)
  if (match) {
      const number = parseInt(match[1], 10) + 1;
      return fileName.replace(/\(\d+\)$/, `(${number})`);
  }
  return fileName; // If no match, return the original fileName
}
 
 async function addRootfile(
    type: boolean,
    props: any,
    Name: any,
    currentUser: any,
    files: any,
    folderName?: string,
    filtersvalue?: any,
    toSetfolders?: any,
    replaceExisting: boolean = false // Added replaceExisting parameter with a default value
) {
    const list = await rhybusRListsHttp().getList(ListNames.POLICY_MEMO);
    const newDate = new Date(); // Current timestamp for modification
 
    // Helper to create a base item object for new entries
    const createNewItemBase = () => ({
        eKey: '',
        eTag: '',
        ItemCreatedBy: currentUser?.userId,
        ItemCreated: newDate, // Set creation date to now for new items
        ItemModified: newDate, // Set modification date to now for new items
        ItemModifiedBy: currentUser?.userId,
    });
 
    try {
        // Handle outer section
        if (props?.Section === 'outer' && !props?.editFile) {
            if (!type) {
                // Adding a new outer folder. If replaceExisting is true, addOrUpdateItem should handle it.
                // Assuming addOrUpdateItem will update if 'Path' already exists.
                await list.addOrUpdateItem({ Path: Name, ...createNewItemBase() });
            } else if (type) {
                // Adding files to outer section
                for (const file of files) {
                    const folderData: any = await list.query().filter(`Path eq '${'general'}'`).get();
                    let pmgFolder;
 
                    if (folderData.length >= 1) {
                        pmgFolder = folderData[0];
                        // Update folder's modified date
                        await list.addOrUpdateItem({
                            ...pmgFolder,
                            ItemModified: newDate,
                            ItemModifiedBy: currentUser?.userId,
                        });
                    } else {
                        // Create 'GENERAL' folder if it doesn't exist
                        pmgFolder = await list.addOrUpdateItem({ Path: 'general', ...createNewItemBase() });
                    }
 
                    // Await the listAttachments_pmg call, passing the replaceExisting flag
                    // This is the critical change for file replacement behavior
                    // Updated call to pass the filename for single file upload
                    await listAttachments_pmg(ListNames.POLICY_MEMO, pmgFolder?.eKey, [file], [file.name], `/${ListNames.POLICY_MEMO}`, currentUser?.profileName);
                }
            }
        } else {
            // For Folder Handling - Create or Edit Folder
            if (props?.addFolder) {
                // Add new folder logic. addOrUpdateItem should handle if it exists and is soft-deleted or needs update.
                const folderData: any = await list.query().filter(`Path eq '${folderName}'`).get();
                if (folderData.length > 0) {
                    const folderItem = folderData[0];
                    // If folder exists, update it. If 'replaceExisting' is true, this update effectively re-creates/overwrites.
                    await list.addOrUpdateItem({
                        ...folderItem,
                        Path: folderName, // Use the new name
                        ItemModified: newDate,
                        ItemModifiedBy: currentUser?.userId,
                        IsDeleted: false // Ensure it's not marked as deleted if being reused/replaced
                    });
                } else {
                    // Folder does not exist, create new
                    await list.addOrUpdateItem({ Path: folderName, ...createNewItemBase() });
                }
                const folderDataAfterUpdate:any = await list.query().filter(`Path eq '${folderName}'`).get();
                const pmgFolder = folderDataAfterUpdate[0];
                // Pass replaceExisting to listAttachments_pmg, even if no files for folder creation
                // Updated call: for empty files array, pass empty fileNames array
                await listAttachments_pmg(ListNames.POLICY_MEMO, pmgFolder?.eKey, [], [], `/${ListNames.POLICY_MEMO}/${folderName}`, currentUser?.profileName);
 
            } else if (props?.editFile) {
                // This section handles file renaming/moving (blobMove).
                // If the new name conflicts, blobMove should handle the conflict based on its implementation.
                if (props?.editFileItem) {
                    const file = props?.editFileItem;
                    await list.blobs().blobMove(props?.FolderId, file?.fileName, file.folderName, file.eTag, Name);
                } else if (props?.details) {
                    const file = props?.details;
                    await list.blobs().blobMove(file?.ID, props?.folderName, props?.selectedFile?.folderName, props?.selectedFile?.eTag, Name);
                }
            } else if (props?.addFolderFile === true) {
                // Adding files to an existing folder
                for (const file of files) {
                    const folderData: any = await list.query().filter(`Path eq '${props?.folderName}'`).get();
                    let pmgFolder;
                    if (folderData.length >= 1) {
                        pmgFolder = folderData[0];
                        await list.addOrUpdateItem({
                            ...pmgFolder,
                            ItemModified: newDate,
                            ItemModifiedBy: currentUser?.userId,
                        });
                    } else {
                        // Create folder if it doesn't exist
                        pmgFolder = await list.addOrUpdateItem({ Path: props?.folderName, ...createNewItemBase() });
                    }
                    // Await the listAttachments_pmg call, passing the replaceExisting flag
                    // This is the critical change for file replacement behavior
                    // Updated call to pass the filename for single file upload
                    await listAttachments_pmg(ListNames.POLICY_MEMO, pmgFolder?.eKey, [file], [file.name], `/${folderName}`, currentUser?.profileName);
                }
            }
            // Handling generic 'Edit' label (potential overlap with editFolder)
            else if (props?.label === 'Edit') {
                if (props?.Section === 'inner') {
                    const updateItem = {
                        Path: Name,
                        ItemModified: newDate,
                        ItemModifiedBy: currentUser?.userId,
                    };
                    const folder: any = await list.query().filter(`Path eq '${props?.folderName}'`).get();
                    const folderItem = folder?.[0];
                    if (folderItem) {
                        await list.addOrUpdateItem({ ...folderItem, ...updateItem });
                    }
                }
                if (props?.Section === 'outer-attachments') {
                    const file = props?.existingFile;
                    await list.blobs().blobMove(props?.FolderId, file.fileName, `/${ListNames.POLICY_MEMO}`, file.eTag, Name);
                }
            } else if (props?.editFolder) { // Explicit folder editing (rename)
                const folderData: any = await list.query().filter(`Path eq '${props?.folderName}'`).get();
                if (folderData.length > 0) {
                    const folderItem = folderData[0];
                    await list.addOrUpdateItem({
                        ...folderItem,
                        Path: folderName, // New folder name
                        ItemModified: newDate,
                        ItemModifiedBy: currentUser?.userId,
                    });
                } else {
                    await list.addOrUpdateItem({ Path: folderName, ...createNewItemBase() });
                }
            }
        }
    } catch (error: any) {
        console.error('Error caught in addRootfile:', error);
        throw error;
    }
}
    const [inputValues, setInputValues] = useState(() => ({
        Name: props?.editFile
            ? trimExtension(props?.editFileValue ?? '')
            : (props?.folderName ?? ''),
    }));
    const [extension, setExtension] = useState<any>(
        props?.editFile ? getFileExtension(props?.editFileValue ?? '') : ''
    );

    useEffect(() => {
        if (props?.editFile) {
            setInputValues({ Name: trimExtension(props?.editFileValue) });
            setExtension(getFileExtension(props?.editFileValue));
        } else if (props?.folderName) {
            setInputValues({ Name: props?.folderName });
            setExtension('');
        } else {
            setInputValues({ Name: '' });
            setExtension('');
        }
        setIsName(true);
        setIsFile(true);
        setIsNotAllowed(false);
        setIsDuplicate(false);
        setIsModified(true);
        setNoChangesAlert(false);
        setConcurrencyErrorAlert({ show: false, message: '' });
    }, [props?.editFileValue, props?.folderName, props?.addFolder, props?.editFile, props?.editFolder, props?.addFile, props?.addFolderFile]);

    const changeTitle = (e: React.ChangeEvent<HTMLInputElement>) => {
        const name = e.target.value;
        setInputValues({ Name: name });
        // Clear all validation errors when user starts typing, except for the general concurrency alert
        setIsName(true);
        setIsFile(true);
        setIsNotAllowed(false);
        setIsDuplicate(false); // Reset this as well
        setIsModified(true);
        setNoChangesAlert(false);
        setConcurrencyErrorAlert({ show: false, message: '' }); // Clear this alert too
    };

    const saveorupdate = async (folder: any, items: string) => {
        setLoading(true);
        let isValid = true;
        let checkName = true;
        let checkFile = true;
        let isModifiedFlag = true;
        let isNotAllowedFlag = false;
        let isDuplicateFlag = false; // Internal flag for logic

        // Reset concurrency alert at the start of validation
        setConcurrencyErrorAlert({ show: false, message: '' });

        const currentName = inputValues.Name?.trim();
        const originalName = props?.editFile ? trimExtension(props.editFileValue) : props?.folderName?.trim();
        const originalFullNameWithExtension = props?.editFileValue;

        // 1. Validate presence of Name
        if ((props?.addFolder || props?.editFolder || props?.editFile) && !props?.addFile && !props?.addFolderFile) {
            if (!currentName) {
                isValid = false;
                checkName = false;
            }
        }

        // 2. Validate Reserved Characters
        if (currentName && FOLDER_RES_CHAR.some((char: string | undefined) => currentName.includes(char!))) {
            isValid = false;
            isNotAllowedFlag = true;
        }

        // 3. Validate "No changes detected" for edit operations
        if (props?.editFile) {
            if (currentName.toLowerCase() === originalName.toLowerCase()) {
                isValid = false;
                isModifiedFlag = false;
            }
        } else if ((props?.addFolder || props?.editFolder) && currentName.toLowerCase() === originalName?.toLowerCase()) {
            isValid = false;
            isModifiedFlag = false;
        }

        // 4. Client-Side Validate Duplicate Name (set internal flag, but don't immediately set InputText error)
        if (props?.folderNames?.length > 0 && (props?.addFolder || props?.editFolder)) {
            props?.folderNames.forEach((element: { folderName: any }) => {
                const existingNameLower = element?.folderName?.toString().toLowerCase();
                if (props?.addFolder && existingNameLower === currentName.toLowerCase()) {
                    isDuplicateFlag = true;
                } else if (props?.editFolder && existingNameLower === currentName.toLowerCase() && existingNameLower !== originalName.toLowerCase()) {
                    isDuplicateFlag = true;
                }
            });
        }
        // For file edit, check against existing files in the current folder, excluding itself
        if (props?.editFile && props?.files?.[0]?.blobs) {
            const newFileNameWithExt = currentName + '.' + extension;
            props.files[0].blobs.forEach((file: any) => {
                if (file.fileName.toLowerCase() === newFileNameWithExt.toLowerCase() && file.fileName.toLowerCase() !== originalFullNameWithExtension.toLowerCase()) {
                    isDuplicateFlag = true;
                }
            });
        }
        // For add file/add folder file, check if the new file name already exists in the target folder
       if ((props?.addFile || props?.addFolderFile) && files.length > 0) {
    const uploadedFileName = files[0].name.trim(); // Trim spaces here

    if (props?.files?.[0]?.blobs?.some((file: any) => {
        const existingFileNameTrimmed = file.fileName.toLowerCase().trim();
        const uploadedFileNameLower = uploadedFileName.toLowerCase();

      
        return existingFileNameTrimmed === uploadedFileNameLower;
    })) {
        isDuplicateFlag = true;
    }
    else {
        isDuplicateFlag = false;}
}

        // If client-side duplicate is found, set the concurrency alert and mark isValid as false
        if (isDuplicateFlag) {
            isValid = false;
            setConcurrencyErrorAlert({ show: true, message: props?.editFile || props?.addFile || props?.addFolderFile ? 'The File Name Already Exists.Please delete existing file' : 'The Folder Name Already Exists.' });
        }


        // 5. Validate File Upload
        if ((props?.addFile || props?.addFolderFile) && files.length === 0) {
            isValid = false;
            checkFile = false;
        }

        // Update state variables for UI feedback, but *do not* directly set isDuplicate for InputText error
        setIsName(checkName);
        setIsFile(checkFile);
        setIsNotAllowed(isNotAllowedFlag);
        // setIsDuplicate(isDuplicateFlag); // DO NOT set this here if you only want the alert
        setIsModified(isModifiedFlag);
        setNoChangesAlert(!isModifiedFlag);

        if (isValid && isModifiedFlag) {
            try {
                let nameToSave = inputValues.Name;
                if (props?.editFile && currentName.toLowerCase() !== originalName.toLowerCase()) {
                    nameToSave = inputValues.Name + '.' + extension;
                } else if (props?.editFile && currentName.toLowerCase() === originalName.toLowerCase()) {
                    nameToSave = originalFullNameWithExtension;
                }

                await addRootfile(
                    props?.addFile || props?.addFolderFile,
                    props,
                    nameToSave.trim(),
                    me,
                    files,
                    inputValues.Name.trim(), // Trim the name here before passing to addRootfile
                    props?.filtersvalue,
                    props.toSetfolders
                );

                if (typeof props.cancel === 'function') {
                    props?.cancel();
                }
                await props.fetchData();
                await props.toSetfolders();
                props?.setShowAddEdit(false);
                props?.setAddFolderFile(false);
            } catch (error: any) {
                console.error('Error during save/update:', error);
                // Unify server-side duplicate handling to always show the alert
                if (error && typeof error === 'object' && (error.name === 'DuplicateError' || (error.message && error.message.includes('DuplicateError')) || (error.message && error.message.includes('already exists')))) {
                    setConcurrencyErrorAlert({ show: true, message: props?.editFile || props?.addFile || props?.addFolderFile ? 'The File Name Already Exists.Please delete existing fileeee' : 'The Folder Name Already Exists.' });
                } else if (error.message && error.message.includes('ConcurrencyError')) {
                    setConcurrencyErrorAlert({ show: true, message: 'File Name already exists.Please delete existing File' });
                } else {
                    setConcurrencyErrorAlert({ show: true, message: error.message || 'An unexpected error occurred.' });
                }
            } finally {
                setLoading(false);
            }
        } else {
            // If validation failed for reasons other than duplicate (e.g., empty name, forbidden chars)
            // ensure that only the relevant InputText error is shown.
            // The duplicate alert is already handled above if isDuplicateFlag is true.
            setLoading(false);
        }
    };

    const cancel = () => {
        if (typeof props?.filtersvalue === 'function') {
            props?.filtersvalue(!props?.showAddEdit);
        }
        if (typeof props?.cancel === 'function') {
            props?.cancel();
        }
        setIsName(true);
        setIsFile(true);
        setIsNotAllowed(false);
        setIsDuplicate(false);
        setIsModified(true);
        setNoChangesAlert(false);
        setConcurrencyErrorAlert({ show: false, message: '' });
    };

    function NoChangespopupclose() {
        setNoChangesAlert(false);
        cancel();
    }

    function ConcurrencyErrorPopupClose() {
        setConcurrencyErrorAlert({ show: false, message: '' });
        cancel()
    }

    return (
        <>
            {loading ? (
                <PageOverlay />
            ) : (
                <div
                    className={
                        props?.showAddEdit
                            ? 'whitebg add-settings-popup'
                            : ''
                    }
                >
                    <div className='add-settings-header'>
                    {props?.showAddEdit && !props?.addFolderFile && (
                        <div>
                            <h4 className='rb-settings-title'>
                                {props?.addFolder && (
                                    <span tabIndex={0} aria-label='add folder'>
                                        Add Folder
                                    </span>
                                )}
                                {props?.editFolder && (
                                    <span tabIndex={0} aria-label='edit folder'>
                                        Edit Folder
                                    </span>
                                )}
                                {props?.editFile && (
                                    <span tabIndex={0} aria-label='edit file'>
                                        Edit File
                                    </span>
                                )}
                                {props?.addFile && (
                                    <span tabIndex={0} aria-label='add file'>
                                        Add File
                                    </span>
                                )}
                            </h4>
                        </div>
                    )}
                    <div className='row' ref={props?.popupBodyRef}>
                        {(props?.addFolder || props?.editFolder || props?.editFile) &&
                            !props?.addFile &&
                            !props?.addFolderFile && (
                                <div className='col-sm-12 col-lg-12 mb-2 mt-0'>
                                   <RhyBusInputText
                                        label=' Name '
                                        isMandatory
                                        info='Name '
                                        onChange={changeTitle}
                                        error={!isName || !isModified || isNotAllowed}
                                        errorMessage={
                                            !isName ? 'Name is required.' :
                                            !isModified ? 'No changes detected.' :
                                            isNotAllowed ? 'Name contains invalid characters.' : ''
                                        }
                                        value={inputValues.Name}
                                        autoComplete={false}
                                    />
                                </div>
                            )}
                        {!props?.editFile &&
                            (props?.addFile || props?.addFolderFile) &&
                            !props?.addFolder &&
                            !props?.editFolder && (
                                <div className='col-sm-12 col-lg-12 mb-2 mt-0'>
                                    <FileUpload
                                        label='Attach File(s)'
                                        info='Attach File(s)'
                                        mandatory={true}
                                        files={files}
                                        setFiles={setFiles}
                                        setFileError={() => setIsFile(true)}
                                        fileError={!isFile}
                                        hint='Upload files in .png, .jpeg, .xlsx, .txt, .docx, and .pdf formats. Special characters should not be used in document names. The maximum file size is 25 MB, and you can upload up to 10 files per screen.'
                                        note='Screenshots need to be saved locally before uploading into system.'
                                    />
                                </div>
                            )}
                    </div>
                    </div>
                    <div className='rb-settings-footer'>
                        <div className='ms-auto d-flex align-items-center gap-2'>
                            {((props?.showAddEdit && !props?.folderName && !props?.editFile) || props?.addFolderFile) && (
                                <>
                                    <Buttons
                                        leftIcon={btnBGColouredCRUDOperationsUI.Save.Icon}
                                        label={btnBGColouredCRUDOperationsUI.Save.Label}
                                        className={btnBGColouredCRUDOperationsUI.Save.ClassName}
                                        onClick={() => {saveorupdate(props?.folderName, '');}}
                                        variant='primary'
                                    />
                                    <Buttons
                                        leftIcon={btnBGColouredCRUDOperationsUI.Cancel.Icon}
                                        label={btnBGColouredCRUDOperationsUI.Cancel.Label}
                                        className={btnBGColouredCRUDOperationsUI.Cancel.ClassName}
                                        onClick={() => {cancel()}}
                                        variant='secondary'
                                    />
                                </>
                            )}
                            {((props?.folderName && !props?.addFolderFile) || (props?.editFile)) && (
                                <>
                                    <Buttons
                                       leftIcon={btnBGColouredCRUDOperationsUI.Update.Icon}
                                        label={btnBGColouredCRUDOperationsUI.Update.Label}
                                        className={btnBGColouredCRUDOperationsUI.Update.ClassName}
                                        onClick={() => {saveorupdate(props?.folderName, '');}}
                                        variant='primary'
                                    />
                                    <Buttons
                                        leftIcon={btnBGColouredCRUDOperationsUI.Cancel.Icon}
                                        label={btnBGColouredCRUDOperationsUI.Cancel.Label}
                                        className={btnBGColouredCRUDOperationsUI.Cancel.ClassName}
                                        onClick={() => {cancel()}}
                                        variant='secondary'
                                    />
                                </>
                            )}
                        </div>
                    </div>
                </div>
            )}
         

            {concurrencyErrorAlert.show && (
                <RhyBusAlert
                    size='md'
                    className="alert-info"
                    message={concurrencyErrorAlert.message}
                    confirmLabel="OK"
                    onConfirm={ConcurrencyErrorPopupClose}
                    show
                />
            )}
        </>
    );
};

export default AddeditView;